export default __webpack_public_path__ + "static/media/Search_Button.927c10d2.svg";